import { Slider as BaseSlider } from '@base-ui-components/react/slider'
import type { FC } from 'react'
import styles from './slider.module.css'

export interface SliderProps {
  value?: number
  defaultValue?: number
  min?: number
  max?: number
  step?: number
  disabled?: boolean
  orientation?: 'horizontal' | 'vertical'
  color?: 'primary' | 'secondary'
  size?: 'small' | 'medium'
  onChange?: (event: Event, value: number) => void
  onChangeCommitted?: (event: Event, value: number) => void
  valueLabelDisplay?: 'auto' | 'on' | 'off'
  valueLabelFormat?: (value: number) => string
  className?: string
  style?: React.CSSProperties
  name?: string
}

export const Slider: FC<SliderProps> = ({
  value,
  defaultValue = 0,
  min = 0,
  max = 100,
  step = 1,
  disabled,
  orientation = 'horizontal',
  onChange,
  onChangeCommitted,
  valueLabelDisplay = 'off',
  valueLabelFormat,
  className,
  style,
  name,
}) => {
  const classes = [styles.slider, className].filter(Boolean).join(' ')
  const showLabel = valueLabelDisplay !== 'off'
  const displayValue = value ?? defaultValue
  const labelText = valueLabelFormat ? valueLabelFormat(displayValue) : String(displayValue)

  return (
    <BaseSlider.Root
      className={classes}
      style={style}
      value={value}
      defaultValue={defaultValue}
      min={min}
      max={max}
      step={step}
      disabled={disabled}
      orientation={orientation}
      name={name}
      onValueChange={(val) => {
        const v = Array.isArray(val) ? val[0] : val
        onChange?.(new Event('change'), v as number)
      }}
      onValueCommitted={(val) => {
        const v = Array.isArray(val) ? val[0] : val
        onChangeCommitted?.(new Event('change'), v as number)
      }}
    >
      <BaseSlider.Control className={styles.control}>
        <BaseSlider.Track className={styles.rail}>
          <BaseSlider.Indicator className={styles.track} />
          <BaseSlider.Thumb className={styles.thumb}>
            {showLabel ? <span className={styles.valueLabel}>{labelText}</span> : null}
          </BaseSlider.Thumb>
        </BaseSlider.Track>
      </BaseSlider.Control>
    </BaseSlider.Root>
  )
}
